import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPivotTableEmpty = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={297}
    height={252}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="M24.49 53.236h247.174V216.12c0 4.451-3.57 8.06-7.974 8.06H32.463c-4.404 0-7.974-3.609-7.974-8.06V53.236Z"
    />
    <path
      fill="#E0E3E9"
      fillRule="evenodd"
      d="M267.677 57.266H28.476v158.853c0 2.226 1.785 4.03 3.987 4.03H263.69c2.202 0 3.987-1.804 3.987-4.03zm-243.188-4.03V216.12c0 4.451 3.57 8.06 7.974 8.06H263.69c4.404 0 7.974-3.609 7.974-8.06V53.236z"
      clipRule="evenodd"
    />
    <path fill="#E0E3E9" d="M120.174 220.187V52.956h6.504v167.231z" />
    <path
      fill="#E0E3E9"
      d="M24.49 108.445c0-1.452 1.164-2.63 2.601-2.63h241.971c1.437 0 2.602 1.178 2.602 2.63v1.315c0 1.453-1.165 2.63-2.602 2.63H27.092c-1.438 0-2.603-1.177-2.603-2.63v-1.315Z"
    />
    <path
      fill="#E0E3E9"
      d="M194.533 224.166c-1.436 0-2.601-1.177-2.601-2.63V55.853c0-1.452 1.165-2.63 2.601-2.63h1.301c1.437 0 2.602 1.178 2.602 2.63v165.683c0 1.453-1.165 2.63-2.602 2.63z"
    />
    <path
      fill="#E0E3E9"
      d="M24.49 167.625c0-1.452 1.164-2.63 2.601-2.63h241.971c1.437 0 2.602 1.178 2.602 2.63v1.315c0 1.452-1.165 2.63-2.602 2.63H27.092c-1.438 0-2.603-1.178-2.603-2.63v-1.315Zm0-134.127c0-3.63 2.912-6.574 6.504-6.574h234.165c3.593 0 6.505 2.943 6.505 6.575v19.724H24.489V33.499Z"
    />
    <path
      fill="#E0E3E9"
      fillRule="evenodd"
      d="M267.677 57.265H28.476v158.853c0 2.226 1.785 4.03 3.987 4.03H263.69c2.202 0 3.987-1.804 3.987-4.03zm-243.188-4.03v162.883c0 4.451 3.57 8.06 7.974 8.06H263.69c4.404 0 7.974-3.609 7.974-8.06V53.235z"
      clipRule="evenodd"
    />
    <path
      fill="#E0E3E9"
      d="M32.463 224.376c-4.404 0-7.974-3.608-7.974-8.059V57.145h30.458v167.231z"
    />
  </svg>
);
export default SvgPivotTableEmpty;
